const KEY = 'weave_session_id';

export function startWeaveSession() {
  try {
    if (getWeaveSessionId() != null) return;
    sessionStorage.setItem(KEY, crypto.randomUUID());
  } catch (e) {
    // Handle or log error if needed
  }
}

export function getWeaveSessionId(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch (e) {
    // Handle or log error if needed
    return null;
  }
}

export function deleteWeaveSessionId(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    // Handle or log error if needed
  }
}
